import reserved from './reserved'
import path from './path'
import record from './record'
import settings from './settings'

const zhCN = { 
  visitorMana: {
    reserved: reserved.zhCN,
    path: path.zhCN,
    record: record.zhCN,
    settings: settings.zhCN
  }
}
const enUS = { 
  visitorMana: {
    reserved: reserved.enUS,
    path: path.enUS,
    record: record.enUS,
    settings: settings.enUS
  }
}
export default { zhCN, enUS }